function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { connect } from 'react-redux';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import App from 'modules/App';
import * as selectors from '../../selectors';
import messages from '../../messages';
import styles from './BgmStatistics.pcss';
var _React_Component;
class BgmStatistics extends (_React_Component = React.Component) {
    renderDateRange() {
        const { highlightedDates } = this.props;
        const startTime = moment(highlightedDates[0], 'YYYY-MM-DD');
        const endTime = moment(highlightedDates[highlightedDates.length - 1], 'YYYY-MM-DD');
        return /*#__PURE__*/ _jsx("div", {
            className: "statisticsSection",
            children: /*#__PURE__*/ _jsxs("div", {
                className: "statisticsSection__row",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "statisticsSection__label",
                        children: /*#__PURE__*/ _jsxs("p", {
                            className: "statisticsSection__elementHighlight",
                            children: [
                                startTime.format('DD  MMM YYYY'),
                                ' - ',
                                endTime.format('DD  MMM YYYY')
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "statisticsSection__value",
                        children: /*#__PURE__*/ _jsxs("p", {
                            className: "statisticsSection__elementHighlight",
                            children: [
                                endTime.diff(startTime, 'days') + 1,
                                " ",
                                /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.days))
                            ]
                        })
                    })
                ]
            })
        });
    }
    renderAllReadingsCount() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "statisticsSection__row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__label",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.readingsCount))
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__divider"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__value",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: this.props.readingsCount
                    })
                })
            ]
        });
    }
    renderReadingsPerDay() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "statisticsSection__row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__label",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.readingsPerDay))
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__divider"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__value",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: this.props.readingsPerDay
                    })
                })
            ]
        });
    }
    renderAverageGlucose() {
        const { conversion } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "statisticsSection__row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__label",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.averageGlucose))
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__divider"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__value",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: `${this.props.readingsAverage} ${conversion.unitSymbol}`
                    })
                })
            ]
        });
    }
    renderAverageBeforeMealGlucose() {
        const { conversion, preMealAverage, preMealCount } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "statisticsSection__row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__label",
                    children: /*#__PURE__*/ _jsxs("p", {
                        className: "statisticsSection__element",
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.averagePreMeal)),
                            preMealCount > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    ' ',
                                    "(",
                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.labels.checks), {
                                        values: {
                                            count: preMealCount
                                        }
                                    })),
                                    ")"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__divider"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__value",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: preMealAverage ? `${preMealAverage} ${conversion.unitSymbol}` : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.unableToCalculate))
                    })
                })
            ]
        });
    }
    renderAveragePostMealGlucose() {
        const { conversion, postMealAverage, postMealCount } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "statisticsSection__row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__label",
                    children: /*#__PURE__*/ _jsxs("p", {
                        className: "statisticsSection__element",
                        children: [
                            /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.averagePostMeal)),
                            postMealCount > 0 && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    ' ',
                                    "(",
                                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread_props(_object_spread({}, messages.labels.checks), {
                                        values: {
                                            count: postMealCount
                                        }
                                    })),
                                    ")"
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__divider"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__value",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: postMealAverage ? `${postMealAverage} ${conversion.unitSymbol}` : /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.unableToCalculate))
                    })
                })
            ]
        });
    }
    renderLowestHighestReadingResult() {
        const { conversion } = this.props;
        return /*#__PURE__*/ _jsxs("div", {
            className: "statisticsSection__row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__label",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.lowestHighestReading))
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__divider"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__value",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: `${this.props.minValue}/${this.props.maxValue} ${conversion.unitSymbol}`
                    })
                })
            ]
        });
    }
    renderCV() {
        return /*#__PURE__*/ _jsxs("div", {
            className: "statisticsSection__row",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__label",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.labels.CV))
                    })
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__divider"
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "statisticsSection__value",
                    children: /*#__PURE__*/ _jsx("p", {
                        className: "statisticsSection__element",
                        children: `${this.props.CV}%`
                    })
                })
            ]
        });
    }
    render() {
        const { highlightedDates } = this.props;
        if (!highlightedDates.length) return null;
        return /*#__PURE__*/ _jsxs("div", {
            className: styles.statisticsSection,
            children: [
                this.renderDateRange(),
                /*#__PURE__*/ _jsxs("div", {
                    className: "statisticsSection",
                    children: [
                        this.renderAllReadingsCount(),
                        this.renderReadingsPerDay(),
                        this.renderAverageGlucose(),
                        this.renderAverageBeforeMealGlucose(),
                        this.renderAveragePostMealGlucose(),
                        this.renderLowestHighestReadingResult(),
                        this.renderCV()
                    ]
                })
            ]
        });
    }
}
_define_property(BgmStatistics, "propTypes", {
    // Explicit props
    conversion: PropTypes.object.isRequired,
    readingsCount: PropTypes.number,
    readingsPerDay: PropTypes.string,
    readingsAverage: PropTypes.number,
    preMealAverage: PropTypes.number,
    postMealAverage: PropTypes.number,
    preMealCount: PropTypes.number,
    postMealCount: PropTypes.number,
    maxValue: PropTypes.number,
    minValue: PropTypes.number,
    CV: PropTypes.number,
    // Implicit props
    highlightedDates: PropTypes.arrayOf(PropTypes.string)
});
const mapStateToProps = (state)=>({
        highlightedDates: selectors.highlightedDates(state),
        direction: App.selectors.direction(state)
    });
const ConnectedBgmStatistics = connect(mapStateToProps)(BgmStatistics);
export default withStyles(styles)(ConnectedBgmStatistics);
